export default {
    url: '/tasklist',
    template: '<ui-view></ui-view>',
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/settings/tasklist/index.js